import React from 'react';

import PropTypes from 'prop-types';

import { Heading, HeadingSize } from '@user-interviews/ui-design-system';

import classNames from 'classnames';

import { LinkButton, AuthenticationType } from './components/link_button';

import * as styles from './new_session_picker.module.css';

export function NewSessionPicker({ isSignin }) {
  return (
    <div className={classNames(styles.root)}>
      {isSignin ? (
        <Heading className={styles.header} level={1}>
          Sign in as a...
        </Heading>
      ) : (
        <>
          <Heading className={styles.mainHeader} level={1}>
            Let&apos;s get that account created!
          </Heading>
          <Heading className={styles.header} level={2} size={HeadingSize.LARGE}>
            Sign up as a...
          </Heading>
        </>
      )}
      <div className={styles.linkButtons}>
        <LinkButton
          authenticationType={AuthenticationType.Researcher}
          isSignin={isSignin}
        />
        <LinkButton
          authenticationType={AuthenticationType.Participant}
          isSignin={isSignin}
        />
      </div>
    </div>
  );
}

NewSessionPicker.propTypes = {
  isSignin: PropTypes.bool.isRequired,
};
